module.exports = __webpack_public_path__ + "static/img/s-thumb.0749809.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/testimonial/s-thumb.png
// module id = 8kZG
// module chunks = 0